import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { media } from 'styles/media'
import typeStyle from 'styles/typeStyle'

import HelpCard from '../../../components/cards/HelpCard'
import ButtonLink from '../../../components/display/ButtonLink'
import SimpleA from '../../../components/display/SimpleAnchor'

const Heading = styled.h4`
  ${typeStyle('-ds-font-section-title-regular')}
  margin: 0;
  color: ${({ theme }) => theme['-ds-core-300'].value};
`

const Text = styled.div`
  ${typeStyle('-ds-font-lead-light')}
  text-align: center;
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--ds-space-04);
  max-width: 950px;
  margin: 0 auto;
  padding: 0;

  ${ButtonLink} {
    margin-top: 24px;
  }

  ${media.md`
    padding: 30px 0;
  `}
`

const Help = () => {
  const [t] = useTranslation()

  return (
    <HelpCard>
      <ContentWrapper>
        <Heading>We&apos;re here to support you</Heading>
        <Text>
          Need help signing up as a host or setting up your listing? Our Support
          Team are always on hand to answer your questions. Just contact them
          via live chat, or visit our{' '}
          <SimpleA
            href="http://help.riparide.com/en/collections/78185-hosting-with-riparide"
            target="_blank"
            rel="noopener noreferrer"
            textDecoration="none"
          >
            {t('helpCenter.name')}
          </SimpleA>
          .
        </Text>
      </ContentWrapper>
    </HelpCard>
  )
}

export default Help
